import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NoLocationMarkerIcon = function NoLocationMarkerIcon(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#1C1327' : _ref$stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "21",
    fill: "none",
    viewBox: "0 0 20 21"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      clipPath: "url(#clip0_2556_29323)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.83 14.43l-3.23 3.23c-.15.15-.34.28-.54.36-.2.08-.42.13-.64.13-.22 0-.44-.04-.64-.13-.2-.08-.39-.21-.54-.36L5.7 14.12a6.617 6.617 0 01-1.82-3.41c-.26-1.29-.13-2.63.38-3.85.25-.61.59-1.17 1.01-1.68M7.92 3.24a6.652 6.652 0 016.2.63 6.66 6.66 0 012.84 6.84c-.1.48-.24.95-.44 1.39"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.25 8.17a2.496 2.496 0 00.39 3.02c.47.47 1.1.73 1.77.73.5 0 .98-.15 1.39-.42M13.05 9.25c0-.66-.26-1.3-.73-1.77s-1.1-.73-1.77-.73M16.92 16.38l-13-13"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_2556_29323",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H14.83V16.9H0z",
          transform: "translate(3 2)"
        })
      })
    })]
  }));
};
export default /*#__PURE__*/React.memo(NoLocationMarkerIcon);